import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CompanyWalletServiceQueryKeys } from '../../user/constants';
import {
  UpdateCompanyDto,
  UserWalletCompanyInfoService,
} from 'services/openapi';

type UpdateCompMutationVariables = UpdateCompanyDto & { compId: string };

export const useUpdateCompMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, UpdateCompMutationVariables>({
      mutationFn: (variables: UpdateCompMutationVariables) => {
        const { compId, ...payload } = variables;
        return UserWalletCompanyInfoService.companyControllerUpdateComp(
          variables.compId,
          { ...payload },
        );
      },
      onSuccess: () =>
        queryClient.invalidateQueries({
          queryKey: [CompanyWalletServiceQueryKeys.GET_COMPANY_INFO],
          exact: true,
        }),
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
